import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { catalogHealthRouter } from './routing/catalogHealthRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { catalogHealthViewAccessControl } from './access-control/catalogHealthAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'catalog-health',
  totem: {
    tool: 'catalog-health-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [catalogHealthRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Catalog,
      attachToV3: NavEntryPointV3.Catalog,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'View catalog health metrics including product visibility, rule violations, and overall quality scores',
          labelId: 'catalogHealthDomain.nav.title',
          labelIdV3: 'catalogHealthDomain.nav.title.v3',
          route: 'catalog-health',
          accessControl: catalogHealthViewAccessControl,
          positionNavV2: 9,
          positionNavV3: 11,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
